import React from 'react'
import {useIntl} from 'react-intl'
import {ControllerRenderProps} from 'react-hook-form'
import {POSTCODE_REGEXP} from '../../utils/constants'
import {CheckPostalCodeFormFields, CreateFields} from '../../types/forms'
import useDeliveryBooking from '../use-delivery-booking'

export function formatPostcode(postcode: string) {
  const cleaned = postcode.replace(/[^a-z0-9]/gi, '').trim()
  const formatted = cleaned.slice(0, -3) + ' ' + cleaned.slice(-3)
  return formatted.toUpperCase()
}

export const useCheckPostcodeFields: CreateFields<
  CheckPostalCodeFormFields,
  {setPostCodeAvailability?: ReturnType<typeof useDeliveryBooking>['setPostCodeAvailability']}
> = ({
  form: {
    control,
    formState: {errors},
  },
  setPostCodeAvailability
}) => {
  const {formatMessage} = useIntl()

  const fields = {
    postcode: {
      name: `postcode` as const,
      label: 'Enter your postcode',
      type: 'text' as const,
      defaultValue: '',
      rules: {
        required: formatMessage({defaultMessage: 'This field is required.'}),
        validate: (postcode: string) => {
          const formatted = formatPostcode(postcode)
          return POSTCODE_REGEXP.test(formatted) || 'Please specify a valid postal code'
        }
      },
      inputProps: ({onChange}: Pick<ControllerRenderProps, 'onChange'>) => ({
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          onChange(e.target.value)
          if (setPostCodeAvailability) {
            setPostCodeAvailability(undefined)
          }
        },
      }),
      error: errors[`postcode`],
      control,
    },
  }

  return fields
}
